module.exports = __webpack_public_path__ + "h5/img/child-nav1.d058c8c6.png";